import React from 'react';

import poweredByGoogle from 'assets/images/externalMedia/poweredByGoogle.svg';
import CloseIcon from 'assets/images/icons/close.svg';
import { Button, Input } from 'components/Atoms';

import * as T from './interfaces';
import * as S from './styles';

export const InputGMPlaces = ({
  id,
  wrapperRef,
  showMedia,
  searchIsActive,
  onCloseIconClick,
  onInputClick,
  ...rest
}: T.IInputGMPlacesProps) => (
  <>
    <S.Wrapper
      ref={wrapperRef}
      data-testid={`${id}@container`}
      id={`${id}@container`}
      searchIsActive={searchIsActive}
    >
      <Input
        onClick={onInputClick}
        onFocus={onInputClick}
        {...rest}
        id={id}
        type="search"
      />
      <Button
        id={`${id}@button`}
        variant="quaternary"
        title="Botão de Fechar a Pesquisa"
        onClick={onCloseIconClick}
      >
        <img src={CloseIcon} alt="Icone de Fechar" />
      </Button>
    </S.Wrapper>
    {showMedia && <S.PoweredBy src={poweredByGoogle} alt="powered by Google" />}
  </>
);
